import styled from 'styled-components';
import SistemaList from '~/pages/Sistema/componentes/SistemaList';
import { Scrollbars } from 'react-custom-scrollbars';

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .content {
    width: 100%;
    overflow: auto;

    padding: 0em 1em 2em 1em;
  }
`;

// export const LandPage = styled(Scrollbars)`
//   width: calc(100%) !important;
// `;

export const Container = styled(SistemaList)`
  margin-top: -30px;
`;
